import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { salaryreport } from "../../../services/admin";
import exportUrl from "../../../exportUrl";

export default function SalaryReport() {
    const [rows, setRows] = useState([]);
    const [totals, setTotals] = useState(null);
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
    ];

    const columnDefs = [
        { headerName: "Staff Name", field: "staff_name", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Staff Code", field: "staff_code", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Month", field: "month", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Year", field: "year", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        {
            headerName: "Pay Date", field: "pay_date", sortable: true, resizable: true, cellStyle: { textAlign: "left" },
            cellRenderer: (p) => (p.value ? moment(p.value).format("DD-MM-YYYY") : ""),
        },
        { headerName: "Gross", field: "gross_salary", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "PF", field: "pf", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "ESI", field: "esi", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "PT", field: "pt", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Total Deduction", field: "total_deduction", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Net Salary", field: "net_salary", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
    ];

    useEffect(() => {
        funlist();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function funlist() {
        setRows([]);
        setTotals(null);
        const temp = new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        temp.append("month", month);
        temp.append("year", year);
        salaryreport(temp).then((res) => {
            if (res.status === true) {
                setRows(res.data.details);
                setTotals(res.data.totals);
            }
        });
    }

    function handleReset() {
        setMonth("");
        setYear("");
        setRows([]);
        setTotals(null);
        const temp = new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        salaryreport(temp).then((res) => {
            if (res.status === true) {
                setRows(res.data.details);
                setTotals(res.data.totals);
            }
        });
    }

    function downloadfile(dtype) {
        const params =
            "branch=" + (localStorage.getItem("branch") || "") +
            "&month=" + (month || "") +
            "&year=" + (year || "") +
            "&type=" + dtype;
        window.open(exportUrl + "report/payslipdownload?" + params, "_blank");
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Salary Report</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a>Reports</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Salary Report</li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label className="form-label">Month</label>
                                            <select className="form-control" value={month} onChange={(e) => setMonth(e.target.value)}>
                                                <option value="">All Months</option>
                                                {months.map((m) => <option key={m} value={m}>{m}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-3">
                                            <label className="form-label">Year</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Year"
                                                maxLength={4}
                                                value={year}
                                                onChange={(e) => {
                                                    const regex = /^[0-9\b]+$/;
                                                    if (e.target.value === "" || regex.test(e.target.value)) setYear(e.target.value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4 d-flex align-items-end">
                                        <div className="mb-3">
                                            <a className="btn btn-primary me-2" onClick={funlist}>Search</a>
                                            <a className="btn btn-secondary" onClick={handleReset}>Reset</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h2 className="main-content-title tx-24 mg-b-5">Salary Report</h2>
                                <div>
                                    <a className="btn btn-danger me-2" onClick={() => downloadfile("pdf")}>Download PDF</a>
                                    <a className="btn btn-success" onClick={() => downloadfile("excel")}>Download Excel</a>
                                </div>
                            </div>
                            <div className="card-body">
                                {totals && (
                                    <div className="row mb-3">
                                        <div className="col-md-3"><b>Gross:</b> {Number(totals.gross).toFixed(2)}</div>
                                        <div className="col-md-3"><b>Total Deduction:</b> {Number(totals.deduction).toFixed(2)}</div>
                                        <div className="col-md-3"><b>Net Salary:</b> {Number(totals.net).toFixed(2)}</div>
                                        <div className="col-md-3"><b>Payslips:</b> {rows.length}</div>
                                    </div>
                                )}
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={rows}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
